import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Progress,
} from "reactstrap";
import { fileToDataUri } from "../../utils/file";
import { fileUpload } from "../../utils/file";
import AWS from "aws-sdk";
import { getConfigAwsS3 } from "../../services/auth";
import { actions as actionsSite } from "../../redux/actions/site";
import Error from "../../components/messagesModal/error";

const UploadS3 = ({
  extensions,
  autoUpload = false,
  folder = "logoSite",
  bucket = "storage-whitelabel",
  callback = console.log,
  args = {}
}) => {
  // const [file, setFile] = useState({});
  const [percentual, setPercentual] = useState(0);
  const [uploadInProgress, setUploadInProgress] = useState(false);
	const inputRef = useRef();
  const dispatch = useDispatch();

  const configAWS = async () => {
    const result = await getConfigAwsS3();
    AWS.config.update({...result.credential, region:"sa-east-1"});
  };

  useEffect(() => {
    const run = async () => {
      await configAWS();
    };
    run();
  }, []);

  const addFile = async (e) => {
    const _file = e.target.files[0];
    const data = await fileToDataUri(e.target.files[0]);
    const params = { name: _file.name, data };
    if (data) {
      const fileToUp = fileUpload(params);

      if (extensions) {
        if (!extensions.includes(fileToUp.ext)) {
          const configModal = {
            component: <Error msg={`Tipo de arquivo "${fileToUp.ext}" não é permitido`} />,
            title: "Erro ao fazer upload",
          };
          dispatch(actionsSite.setModal(configModal));
          return;
        }
      }

      // setFile(fileToUp);

      if (autoUpload) {
        actionUpload(fileToUp);
      }
    }
  };

  const updateProgress = (p) => {
    setPercentual(p);
  };

  const actionUpload = (file) => {
    startUpload(file).on("httpUploadProgress", (progress) => {
      let progressPercentage = Math.round(
        (progress.loaded / progress.total) * 100
      );
      updateProgress(progressPercentage);
    });
  };

  const startUpload = (file) => {
    setUploadInProgress(true);
    const bucketS3 = new AWS.S3({ params: { Bucket: bucket } });
    const buff = Buffer.from(file.base64, "base64");
    var data = {
      Key: folder + "/" + Date.now() + "." + file.ext,
      Body: buff,
      ACL: "public-read",
      ContentEncoding: "base64",
      ContentType: file.mimeType,
    };
    return bucketS3.upload(data, (err, returnData) => {
      if (err) {
        console.log(err);
      } else {
        // setFile({});
        inputRef.current.value = "";
        setUploadInProgress(false);
        setPercentual(0);
        callback({ filename: file.name, url: returnData.Location, args });
      }
    });
  };

  const selectFile = () => {
    inputRef.current.click();
  };

  return (
    <div className="d-flex align-items-center">
      <input
        type="file"
        className="custom-file-input"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={(e) => addFile(e)}
      />

      <Button
        style={{ flex: 1 }}
        color="info"
        disabled={uploadInProgress}
        onClick={() => selectFile()}
      >
        <i className="fas fa-cloud-arrow-up"></i> Selecione um arquivo para o
        upload
        <Progress value={percentual} />
      </Button>
      {uploadInProgress && (
        <div className="ml-2" style={{ width: 50, textAlign: "center" }}>
          {percentual}%
        </div>
      )}
    </div>
  );
};

export default UploadS3;
